package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ParentFilterRequest(
    @SerialName("parentNameQuery") val parentNameQuery: String? = null,
    @SerialName("studentQuery") val studentQuery: String? = null,
    @SerialName("classId") val classId: String? = null,
    @SerialName("sectionId") val sectionId: String? = null,
    @SerialName("primaryRelationship") val primaryRelationship: String? = null,
    @SerialName("secondaryRelationship") val secondaryRelationship: String? = null,
    @SerialName("status") val status: String? = null,
    @SerialName("mobileQuery") val mobileQuery: String? = null,
    @SerialName("createdDateFrom") val createdDateFrom: String? = null,
    @SerialName("createdDateTo") val createdDateTo: String? = null
)

@Serializable
data class StudentFilterRequest(
    @SerialName("q") val searchQuery: String? = null,
    @SerialName("classId") val classId: String? = null,
    @SerialName("sectionId") val sectionId: String? = null,
    @SerialName("gender") val gender: String? = null,
    @SerialName("status") val status: String? = null,
    @SerialName("subjectCodes") val subjectCodes: List<String>? = null,
    @SerialName("bloodGroup") val bloodGroup: String? = null,
    @SerialName("createdDateFrom") val createdDateFrom: String? = null,
    @SerialName("createdDateTo") val createdDateTo: String? = null
)

@Serializable
data class SchoolStaffFilterRequest(
    @SerialName("staffRole") val staffRole: String? = null,
    @SerialName("authRole") val authRole: String? = null,
    @SerialName("gender") val gender: String? = null,
    @SerialName("status") val status: String? = null,
    @SerialName("createdDateFrom") val createdDateFrom: String? = null,
    @SerialName("createdDateTo") val createdDateTo: String? = null,
    @SerialName("name") val name: String? = null,
    @SerialName("employeeId") val employeeId: String? = null,
    @SerialName("email") val email: String? = null,
    @SerialName("mobile") val mobile: String? = null
)
